<template>
    <el-tabs type="border-card" @tab-click="SetData" v-model="Act">
      <el-tab-pane label="基础配置" name="Basic">
            <AdminBasic v-if="Act == 'Basic'"></AdminBasic>
      </el-tab-pane>
      <el-tab-pane label="信息项配置" name="Info">
            <AdminInfo v-if="Act == 'Info'"></AdminInfo>
      </el-tab-pane>
      <el-tab-pane label="规则项配置" name="Rules">
            <AdminRules v-if="Act == 'Rules'"></AdminRules>
      </el-tab-pane>
      <el-tab-pane label="专家领域配置" name="LingYu">
            <AdminLingYu v-if="Act == 'LingYu'"></AdminLingYu>
      </el-tab-pane>
      <!-- <el-tab-pane label="保密协议配置" name="BMXY">
            <div class="XyHead">
                <Toolbar v-show="Act == 'BMXY'" style="border-bottom: 1px solid #ccc" :editor="editor"/>
                <Editor v-show="Act == 'BMXY'" style="height: 500px; overflow-y: hidden;" v-model="EditorCont" @onCreated="onCreated" />
            </div>
            <el-button v-throttle type="primary" size="mini" @click="SucXieYi">保存</el-button>
      </el-tab-pane> -->
    </el-tabs>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
    data() {
        return {
            Act:"Basic",
            editor: null,
            EditorCont: '',
            toolbarConfig: {
              excludeKeys: ['uploadVideo']
            }
        };
    },
    components: { Editor, Toolbar },
    methods: {
        SetData(tab) {
            this.Act = tab.name;
        },
        async handleEditorUpload(file, insertFn) {
            const fd = new FormData()
            fd.append('file', file)
            try {
                await this.$post("/common/upload/image", fd,{
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }).then((res)=>{
                    insertFn(this.$Tools.ServeUrl() + res.data.url)
                })
            } catch (err) {
                this.$message.error('网络异常，上传失败')
            }
        },
        onCreated(editor) {
            this.editor = Object.seal(editor)
            const uploadConf = editor.getMenuConfig('uploadImage')
            uploadConf.server = "#"
            uploadConf.customUpload = async (file, insertFn) => {
                await this.handleEditorUpload(file, insertFn)
            }
            this.$get('/admin/expert_field/xieyi',{}).then(res=>{
                if(res){
                    this.EditorCont = res.data.content;
                }
            })
        },
        SucXieYi() {
            this.$post('/admin/expert_field/xieyiEdit',{
                id:"",
                content:this.EditorCont
            }).then(res=>{
                if(res){
                    this.$message.success('保存成功');
                }
            })
        }
    },
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy()
    },
}
</script>

<style scoped>
    .XyHead{
        border:1px solid #ccc;
        margin-bottom: 10px;
    }
</style>